<div>
  <section *ngIf="loading">
    <ngx-skeleton-loader [theme]="{height:'400px'}" ></ngx-skeleton-loader>
 </section>

 <div *ngIf="!loading">
  <div class="flex items-center justify-center w-full banner bg-center bg-cover" style="background-image: url({{this.headerImage}});">
      <div class="flex max:w-2/3 justify-center items-center flex-col p-4">
        <h1 class=" text-center md:text-6xl font-bold text-4xl max-sm:text-left"
          [style.color]="headerTextColor">
          {{headerTitle}}
        </h1>
        <!-- <button class="fuse-mat-button-small w-full mt-8 text-xl" mat-flat-button [color]="'accent'"
          [routerLink]='[""]'>
          Check coverage 
        </button> -->
      </div>
    </div>

    <section>
      <div class="flex-wrap justify-center my-10 max-sm:my-16 px-4 flex-shrink-0">
        <div class="px-5">
          <div class="flex flex-row pb-4 hover:cursor-pointer" routerLink="/product-overview">
            <div class="mr-2">
              <mat-icon svgIcon="heroicons_solid:arrow-left-circle" [color]="'primary'"></mat-icon>
            </div>
            <div class="font-bold">
              Go back
            </div>
          </div>
          <div>
            <div class="text-primary text-4xl font-extrabold">
              Fixed-LTE
            </div>
          </div>
          <hr class="my-5">
          <div class="pb-10">
            <p class="text-black text-lg font-bold text-center">
              Fixed-LTE is wireless internet with fast speeds and reliable connection.
              Supersonic Fixed-LTE has something for every need and budget, from uncapped Wi-Fi deals to capped Wi-Fi packages.
              Plus, you enjoy high-speed internet, month-to-month payments, free activation, and a free-to-use Wi-Fi router!
            </p>
          </div>
        </div>

        <div class="flex flex-wrap gap-x-2 gap-y-2 justify-center info-blocks-container flex-shrink-0 md:space-x-12 max-sm:space-y-12">

          <div 
        class="w-64 max-sm:w-40 flex-shrink-0 max-sm:mt-12 p-2 py-12  max-sm:py-4 bg-white rounded-2xl shadow-md items-center justify-center block">
            <div class="w-full text-center justify-center flex">
              <img src="/assets/icons/best_network.svg" alt="Best Network" loading="lazy" class="w-12 h-12 mb-4 max-sm:w-8 max-sm:h-8 max-sm:mb-2">
            </div>
            <div class="w-full text-center justify-center">
              <h2 class="text-xl max-sm:text-md font-bold mb-2 text-center">Best network</h2>
            </div>
            <div class="w-full text-center justify-center mt-4">
              <p class="text-black text-lg max-sm:text-sm text-center font-medium">Powered by MTN, the best network in South Africa,
                with over 96% LTE coverage.</p>
            </div>
          </div>

          <div 
          class="w-64 max-sm:w-40 flex-shrink-0 p-2 py-12  max-sm:py-4 bg-white rounded-2xl shadow-md items-center justify-center block">
          <div class="w-full text-center justify-center flex">
              <img src="/assets/icons/speed.svg" alt="Speed" class="w-12 h-12 mb-4 max-sm:w-8 max-sm:h-8 max-sm:mb-2" loading="lazy">
            </div>
            <div class="w-full text-center justify-center">
              <h2 class="text-xl max-sm:text-md font-bold mb-2 text-center">Plug & Play</h2>
            </div>
            <div class="w-full text-center justify-center mt-4">
              <p class="text-black max-sm:text-sm text-lg text-center font-medium">No installation, just plug & play.</p>
            </div>
          </div>

          <div
          class="w-64 max-sm:w-40 flex-shrink-0 p-2 py-12  max-sm:py-4 bg-white rounded-2xl shadow-md items-center justify-center block">
            <div class="w-full text-center justify-center flex">
              <img src="/assets/icons/fibre-over-air.svg" alt="Uncapped home internet" class="w-12 h-12 mb-4 max-sm:w-8 max-sm:h-8 max-sm:mb-2" loading="lazy">
            </div>
            <div class="w-full text-center justify-center">
              <h2 class="text-xl max-sm:text-md font-bold mb-2 text-center">Reliability</h2>
            </div>
            <div class="w-full text-center justify-center mt-4">
              <p class="text-black text-lg  max-sm:text-sm text-center font-medium">
                A reliable and stable connection.
              </p>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div>
          <div class="w-full flex flex-col md:flex-row justify-end items-center">
            
            <div class=" w-full justify-center text-center px-4">
              <h1 class="text-3xl font-bold text-black">
                We have some amazing Fixed-LTE plans for you!
                 <br>
                Check your coverage to sign-up
              </h1>
            </div>
          </div>

          <div class="border-t-2 border-gray-200 my-4"></div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
            <div class="flex flex-col m-8 items-center justify-center" *ngFor="let p of pagedProducts">
              <fuse-card class="flex flex-col w-[20rem] md:w-[28rem] bg-[#F0F0F0] shadow-lg h-110 p-3 rounded-xl border border=[#F1F1F1]">
                <div class="rounded-xl bg-white p-3">
                  <div *ngIf="p?.Tags.length">
                    <div *ngFor="let t of p.Tags">
                      <span *ngIf="t.TagName !== 'Active Offer'" class="bg-[#FFC41B] px-2 py-1 rounded-bl-lg rounded-tr-lg absolute right-0 top-0 font-extrabold">{{t.TagName}}</span>
                    </div>
                  </div>
                  <div
                    class="w-fit mb-3 flex flex-row text-lg items-center border border-[#302756] rounded-full">
                    <div class="rounded-full bg-[#302756] text-white px-5 py-1">
                      Fixed-LTE
                    </div>
                    <div class="pr-4 pl-3 font-bold">
                      {{p?.packageDescription?.includes('Uncapped') ? "Uncapped" : "Lite" }}
                    </div>
                  </div>
                  <div class="flex flex-col h-full w-full items-start">
                    <div class="text-start text-black flex flex-row items-center">
                      <div class="font-extrabold text-2xl flex items-center">{{p?.packageName}}</div>
                    </div>
                    <!-- If there are no package supplier org entity names - defaulting to Supersonic -->
                    <!-- <div class="text-lg text-center font-bold w-full flex flex-row items center">
                        <div class="gap-x-1 font-extrabold flex flex-row items-center">
                          <mat-icon class="icon-size-6 font-extrabold" [svgIcon]="'heroicons_outline:sun'"></mat-icon>
                          <h1>30 GB</h1>
                        </div>
                        <div class="pl-3 gap-x-1 font-extrabold flex flex-row items-center">
                          <mat-icon class="icon-size-5 font-extrabold" [svgIcon]="'heroicons_outline:moon'"></mat-icon>
                          <h1>30 GB</h1>
                        </div>
                      </div> -->
                    <div class="py-2 w-full">
                      <mat-divider class="py-2"></mat-divider>
                      <span *ngIf="p.UpfrontBenefits !== null" [innerHTML]="p?.UpfrontBenefits | boldKeywords"></span>
                    </div>
                  </div>
                </div>
                <div class="w-full flex flex-row justify-between">
                  <div class="w-full flex flex-col">
                    <div class="flex flex-row text-[#8A3EFF] items-start pb-4 p-0 m-0">
                      <h1 class="text-8xl font-extrabold p-0 m-0">
                        {{"R" + p.totalRecurring}}
                      </h1>
                      <h1 class="text-xl font-extrabold pt-4 px-0">
                        pm*
                      </h1>
                    </div>
                    <!-- <div class="flex flex-row text-[#8A3EFF] items-start p-0 m-0">
                      <h1 class="text-8xl font-extrabold p-0 m-0">
                        {{"R" + p?.totalRecurring}}
                      </h1>
                      <h1 class="text-xl font-extrabold pt-4 px-0">
                        pm*
                      </h1>
                    </div> -->
                    <div class="w-full flex flex-row items-center justify-between -mt-6">
                      <p class="text-xs w-5/6">*Ts and Cs apply. <span *ngIf="p?.Tags === 'Real Deal'">Promotional
                          pricing
                          applies for the first 2 months.</span></p>
                      <button [routerLink]="['/home']" mat-flat-button
                        class="w-full p-2 ml-2 bg-accent-500 text-md font-bold rounded-2xl">
                        Check Coverage
                      </button>
                    </div>
                  </div>
                </div>
              </fuse-card>
            </div>
          </div>
          <mat-paginator #matPaginator id="matPaginator" [length]="totalProducts" [pageSize]="pageSize" (page)="pageEvent($event)"
            [pageSizeOptions]="[6, 12, 24, 48, 96, 108, 132]">
          </mat-paginator>

          <div class="w-full flex items-center justify-center px-12 text-center py-2">
            <h1>Please note: <b>Fixed LTE</b> is not available in every location. It is recommended to do a coverage check for more information on availability.</h1>
          </div>
        </div>
      </section>
    </section>
  </div>
</div>